import { ListenerEffectAPI, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { fetchSync } from '../sync/sync';

const playerSwitchHandler = (listenerApi: ListenerEffectAPI<unknown, ThunkDispatch<unknown, unknown, UnknownAction>, unknown>, payload: any) => {
  listenerApi.dispatch(fetchSync());
}

export default playerSwitchHandler;

